import { UpdateEventEntryInput, UpdateMembershipInput } from "../../API";
import { Result } from "../../interfaces/Result";
import { EventEntry, Horse, Membership } from "../../models";
import { getEventEntriesByHorseId, updateEventEntry } from "../eventEntry/EventEntry";
import { getMembershipsByHorseId, updateMembership } from "../membership/Membership";
import { deleteHorse } from "./Horse";

export async function deleteHorseAndData(horse: Horse, callbackFunction: Function) {
    let result: Result = {
        isSuccess: false,
        type: "Horse",
        message: "Removing horse and its data.",
        result: null
    };

    let progressMessage = "Finding all entries associated with this horse.";
    callbackFunction(progressMessage);

    // Get all entries associated with this horse
    let entries: EventEntry[] = [];
    const entryQuery = await getEventEntriesByHorseId(horse.id);
    if (entryQuery.isSuccess) {
        entries = entryQuery.result;
    }

    for (let i = 0; i < entries.length; i++) {
        const currentEntry = entries[i];

        const percentage = (i+1)/entries.length*100;
        progressMessage = "Cleaning up entries: " + percentage + "% complete.";
        callbackFunction(progressMessage);

        const updateInput: UpdateEventEntryInput = {
            id: currentEntry.id,
            horseId: null,
            horseName: ""
        };

        const updateResult = await updateEventEntry(updateInput);
        if (!updateResult.isSuccess) {
            result = {
                isSuccess: false,
                type: "Horse",
                message: "Could not remove the horse from the event entries.",
                result: null
            };
            return result;
        }
    }

    progressMessage = "Finding all memberships associated with this horse.";
    callbackFunction(progressMessage);

    // Get all memberships associated with this horse
    let memberships: Membership[] = [];
    const membershipQuery = await getMembershipsByHorseId(horse.id);
    if (membershipQuery.isSuccess) {
        memberships = membershipQuery.result;
    }
    for (let i = 0; i < memberships.length; i++) {
        const currentMembership = memberships[i];

        const percentage = (i+1)/entries.length*100;
        progressMessage = "Cleaning up memberships: " + percentage + "% complete.";
        callbackFunction(progressMessage);

        const updateInput: UpdateMembershipInput = {
            id: currentMembership.id,
            horseId: null
        };

        const updateResult = await updateMembership(updateInput);
        if (!updateResult.isSuccess) {
            result = {
                isSuccess: false,
                type: "Horse",
                message: "Could not remove the horse from the memberships.",
                result: null
            };
            return result;
        }
    }

    progressMessage = "Completing deletion of this horse.";
    callbackFunction(progressMessage);

    const deleteHorseInput = {
        id: horse.id
    };
    const deleteResult = await deleteHorse(deleteHorseInput);
    if (deleteResult.isSuccess) {
        result = {
            isSuccess: true,
            type: "Horse",
            message: "Successfully deleted the horse",
            result: deleteResult.result
        };
    }

    return result;
}